import { useCallback, useEffect, useState } from 'react'

import { makePublicUrl } from 'app/utils/publicUrl'

interface ImageProps {
  alt?: string
  defaultUrl?: string
  onError?: (evt: unknown) => void
  url: string
  className?: string
}

export const DEFAULT_IMG = makePublicUrl('images/s-logo.svg')

function Image({
  alt,
  defaultUrl = DEFAULT_IMG,
  onError,
  url,
  className,
}: ImageProps) {
  const [src, setSrc] = useState(url)

  useEffect(() => {
    setSrc(url)
  }, [url])

  const handleError = useCallback(
    (evt) => {
      setSrc(defaultUrl)
      if (onError) {
        onError(evt)
      }
    },
    [setSrc, onError, defaultUrl]
  )

  return (
    <img
      alt={alt || 'No image available'}
      onError={handleError}
      src={src}
      className={className}
    />
  )
}

export default Image
